// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2332":"ad5f6daa","2682":"b0ca3787","3254":"5853b473","4056":"b29def5e","4993":"2fc087f9","6203":"d23130b7","7330":"fb9891e3","8480":"b29def5e","9921":"ad5f6daa"}[chunkId] + ".chunk.css";
};